/** Auto-generated by scripts/sync-build-info.mjs — do not edit by hand. */
export const BUILD_META = {
  appVersion: '1.0.0',
  buildTag: 'bdebf6358baaada9696e9d13c81c6580eac08638',
} as const;
